import React from "react";
// import { styled } from '@mui/material/styles';

import DataTable from "../components/Products/OscarProductTable";

import { Box } from "@mui/material";
import { ProductProvider } from "../Context/ProductContext";

export const CartProduct = () => {
	React.useEffect(() => {
		(async () => {
			// const data = await getUsers();
			// setUsers(data);
		})();
		(async () => {
			// const data = await getProdTags();
			// console.log(data);
			// setTags(data);
		})();
	}, []);

	return (
		<ProductProvider>
			<Box px={5}>
				<DataTable />
			</Box>
		</ProductProvider>
	);
};
